'use client';

import { usePathname } from 'next/navigation';
import { Header } from '@/components/Header';

/**
 * Renders the main site Header only when NOT inside the /app directory.
 * The app directory has its own AppHeader, so we hide this one there to avoid double navbars.
 */
export function ConditionalHeader() {
  const pathname = usePathname();

  // Hide main Header under /<locale>/app (app has its own AppHeader)
  const isAppRoute = pathname?.match(/^\/(en|es|ja)\/app(\/|$)/);
  // Also hide it on the World ID embed page, which renders inside the mobile app's WebView.
  const isWorldIdEmbed = pathname?.match(/^\/[a-z]{2}\/worldid\/embed(\/|$)/);
  if (isAppRoute || isWorldIdEmbed) {
    return null;
  }

  return <Header />;
}
